import React from "react";
import { LegalPage } from "./LegalPage";

export default function Tietosuojaseloste() {
  return <LegalPage docKey="privacy" testId="page-tietosuojaseloste" />;
}
